import {
  Col, Collapse, Divider, Typography,
} from 'antd';
import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { BusinessPartnerWithContracts } from '../../../../../hooks/api/businessPartners';
import CollapseItem from './CollapseContractItem';
import SendWelcomeMailBtn from '../../../Users/View/SendWelcomeMailBtn';

interface ContractsListProps {
  businessPartnerData: BusinessPartnerWithContracts | undefined;
  isSyncRequired?: boolean;
}

export default function ContractsList({ businessPartnerData, isSyncRequired }: ContractsListProps) {
  const [searchParams] = useSearchParams();
  const contracts = useMemo(() => businessPartnerData?.contracts || [], [businessPartnerData?.contracts]);

  return (
    <>
      <Col span={24}>
        <Divider>Contracts</Divider>
      </Col>
      <Collapse
        accordion
        bordered
        defaultActiveKey={searchParams.get('activeContract') || contracts?.[0]?.contractNumber}
        items={contracts.map((contract, index) => ({
          key: contract.contractNumber,
          label: (
            <span>
              Contract
              {' '}
              <b>
                <Typography.Text copyable>{contract.contractNumber}</Typography.Text>
              </b>
              {contract.tariffId ? ` (tariffId: ${contract.tariffId})` : ''}
              {contract.contractNumber && businessPartnerData?.user?.id ? (
                <>
                  <Divider type="vertical" />
                  <SendWelcomeMailBtn contractNumber={contract.contractNumber} userId={businessPartnerData?.user?.id} />
                </>
              ) : null}
            </span>),
          children: <CollapseItem
            contract={contracts[index]}
            businessPartnerData={businessPartnerData}
            isSyncRequired={isSyncRequired}
          />,
        }))}
      />
    </>
  );
}
